import { RadioButtonGroupInput } from "react-admin";

const YesNoInput = ({ ...props }) => (
  <RadioButtonGroupInput
    {...props}
    choices={[
      { id: "Yes", name: "Yes" },
      { id: "No", name: "No" },
    ]}
  />
);

export default YesNoInput;
